import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Stepper, Step, StepButton, StepLabel } from '@mui/material';
import { Card, Typography } from '@totalsoft/rocket-ui';

const SimulatorStepper = ({ t, activeStepCode, steps, onStepClick }) => {
  const visibleActiveStepIndex = steps.filter(s => s.visible()).findIndex(step => step.code === activeStepCode);

  return (
    <Card>
      <Grid container direction='row' alignItems='center'>
        <Grid item xs={12}>
          <Stepper activeStep={visibleActiveStepIndex}>
            {steps.map((step, idx) => {
              return (
                step.visible() && (
                  <Step disabled={step.disabled} key={step.id}>
                    <StepButton
                      onClick={() => onStepClick(step)}
                      disabled={step.disabled}
                      optional={
                        <Typography variant='caption' color='error'>
                          {step.error}
                        </Typography>
                      }
                    >
                      {idx === visibleActiveStepIndex ? (
                        <StepLabel error={step.error}>
                          <b>{t(step.title)}</b>
                        </StepLabel>
                      ) : (
                        <StepLabel error={step.error}>{t(step.title)}</StepLabel>
                      )}
                    </StepButton>
                  </Step>
                )
              );
            })}
          </Stepper>
        </Grid>
      </Grid>
    </Card>
  );
};

SimulatorStepper.propTypes = {
  t: PropTypes.func.isRequired,
  steps: PropTypes.array.isRequired,
  onStepClick: PropTypes.func.isRequired,
  activeStepCode: PropTypes.string.isRequired
};

export default compose(withTranslation())(SimulatorStepper);
